@if (activeComponent$ | async) {
    <div class="flex-col"
         [ngStyle]="{'width': collapsed$.value ? '40px' : '280px'}"
    >
        <mat-card class="collapsible-card flex-col"
                  *cbWaitFor="mappedItem$ | async">
            <mat-card-content>
                <button mat-mini-fab
                        color="accent"
                        class="collapse-button"
                        (click)="collapsed$.next(!collapsed$.value)"
                        [matTooltip]="collapsed$.value ? 'Expand' : 'Collapse'">
                    <mat-icon>
                        {{ collapsed$.value ? 'chevron_left' : 'chevron_right ' }}
                    </mat-icon>
                </button>
                @if ((collapsed$ | async)) {
                    <div class="flex-row"
                    >
                        <h1 class="mat-headline-6 collapsed-title">User Information</h1>
                    </div>
                }
                @if (!(collapsed$ | async)) {
                    <div class="flex-col flex"
                    >
                        @if (!(activeComponent.isAdd$ | async) && mappedItem) {
                            <h4 class="mat-headline-6">{{ mappedItem.firstName }} {{ mappedItem.lastName }}</h4>
                            <div style="position: relative"
                                 class="cb-margin-bottom-2x">
                                <mat-divider></mat-divider>
                            </div>
                            <h4 class="mat-subtitle-2 cb-margin-bottom-nil">{{ mappedItem.jobTitle }}</h4>
                            <mat-checkbox class="cb-grey read-only cb-margin-bottom"
                                          [checked]="isUserActive$.value"
                                          [disabled]="true">
                                Active
                            </mat-checkbox>
                        }
                        @if ((activeComponent.isView$ | async)) {
                            <cb-button class="cb-margin-bottom flex-col"
                                       [disabled]="isReportDisabled$ | async"
                                       (clicked)="generateFullUserDetailReport()">
                                User Security Report
                            </cb-button>
                        }
                        @if ((activeComponent.isView$ | async) && canEditUsers) {
                            <cb-button class="cb-margin-bottom flex-col"
                                       (clicked)="editItem()">
                                Edit
                            </cb-button>
                        }
                        @if (activeComponent.isEditOrAdd$ | async) {
                            <cb-button class="cb-margin-bottom flex-col"
                                       [disabled]="isSaveDisabled$ | async"
                                       (clicked)="save()">
                                Save
                            </cb-button>
                        }
                        @if (activeComponent.isEditOrAdd$ | async) {
                            <cb-button class="cb-margin-bottom flex-col"
                                       (clicked)="cancel()">
                                Cancel
                            </cb-button>
                        }
                    </div>
                }
            </mat-card-content>
        </mat-card>
    </div>
}
